module.exports = __webpack_public_path__ + "img/ic_like_curve_normal.8e919d6d.svg";